<template>
  <div>
    <span @click="goBack" class="s-18 fw-400 cursor-pointer text-black">
      <img src="../../assets/goback.png" alt="" />
      {{ navigatorLang === "en-US" ? "Go back" : $t("event.goBack") }}
    </span>
  </div>
</template>

<script setup>
import { ref } from "vue";
import router from "@/router/index";
const navigatorLang = ref(navigator.language);

const goBack = () => {
  router.go(-1);
};
</script>
